module.exports = __webpack_public_path__ + "img/legende325.fbe65c55.jpg";